import logo from "./logo.svg";
import "./App.css";
import Routes from "./routes.js";
import "antd/dist/antd.css";
import zhCN from "antd/lib/locale/zh_CN";
import { ConfigProvider } from "antd";

function App() {
  return (
    <>
      <ConfigProvider locale={zhCN}>
        <Routes />
      </ConfigProvider>
    </>
  );
}

export default App;
